module.exports = __webpack_public_path__ + "static/img/zeta_template_07.270f210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeta_template_07.png
// module id = s5Qu
// module chunks = 1